import { Download } from "lucide-react";
import type { LegislationListComponent } from "../../types";
import { GuardedLink } from "../../runtime/DevPlaceholder";
import { isExternalHref } from "../../utils/links";

const DOWNLOAD_ICON_COLOR = "#FFA401";

/** Legislation document list renderer with download icon. Items whose document isn't
 *  connected keep their label as plain text in production (no underline, no download
 *  icon) and open the dev modal in preview. */
export function LegislationListRenderer({ component }: { component: LegislationListComponent }) {
  const { items } = component.content;
  return (
    <section className="mt-4 md:mt-6">
      <ul className="space-y-3 md:space-y-4 list-none p-0 m-0">
        {items.map((item, idx) => {
          const openInNewTab = isExternalHref(item.href);
          return (
            <li key={`${item.label}-${idx}`}>
              <GuardedLink
                href={item.href}
                label={item.label}
                fallback="unwrap"
                unwrapClassName="text-[#0F2849]"
                unwrapChildren={item.label}
                className="inline-flex items-center gap-2 md:gap-3 text-[#005CA9] underline hover:no-underline"
                {...(openInNewTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              >
                <span>{item.label}</span>
                <span className="shrink-0" style={{ color: DOWNLOAD_ICON_COLOR }} aria-hidden>
                  <Download className="h-5 w-5" stroke="currentColor" />
                </span>
              </GuardedLink>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
